import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

    public qrdata: string = 'Data to encode in the QR code';


   printLabels(): void {
    window.print();
  }

}
